// extracted by mini-css-extract-plugin
export var backdropBlur = "_jo-0";
export var contentCard = "_jo-5";
export var frame = "_jo-2";
export var image = "_jo-4";
export var imagePane = "_jo-3";
export var modal = "_jo-1";